import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d1c58bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-tie me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "region",
  class: "form-label text-muted"
}, " เขตตรวจราชการ: ", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "appointmentRegionForm",
    backdrop: "static",
    overflow: true,
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("input", {
            type: "text",
            value: _ctx.region?.name,
            class: "form-control",
            readonly: true,
            "aria-label": "region",
            autocomplete: "off"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", {
            for: "provinces",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.provinces}])
          }, " จังหวัด: ", 2),
          (_ctx.submited && _ctx.errors.provinces)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " * กรุณาเลือกจังหวัด "))
            : _createCommentVNode("", true),
          _createVNode(_component_Multiselect, {
            modelValue: _ctx.formData.provinces,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.provinces) = $event)),
            mode: "tags",
            placeholder: "กรุณาเลือกจังหวัด",
            searchable: true,
            options: _ctx.provinceOptions
          }, null, 8, ["modelValue", "options"])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            disabled: _ctx.isLoading,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_9,
            _createTextVNode(" ลบ ")
          ], 8, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_11,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_10),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_13,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_12)
    ]),
    _: 1
  }, 8, ["onHide"]))
}